"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _app = require("@package/app");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Item(_ref) {
  var isActive = _ref.isActive,
      disabled = _ref.disabled,
      children = _ref.children,
      onClick = _ref.onClick;

  try {
    var handleClick = function handleClick() {
      if (disabled) {
        return void 0;
      }

      if (onClick) {
        onClick();
      }
    };

    var wrapperClassName = _react["default"].useMemo(function () {
      var _cn;

      return (0, _classnames["default"])(_defaultModule["default"]['wrapper'], (_cn = {}, (0, _defineProperty2["default"])(_cn, _defaultModule["default"]['active'], isActive), (0, _defineProperty2["default"])(_cn, _defaultModule["default"]['disabled'], disabled), _cn));
    }, [isActive, disabled]);

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: wrapperClassName,
      onClick: handleClick
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['content']
    }, children));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Item;
exports["default"] = _default;